import url from './url';

async function handleEventos() {

    let data = await fetch(`${url}/eventos`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

export { handleEventos }